 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~eaaaa58d","1":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~f41b84c5","2":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","3":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~326164d8","4":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~5c0a4254","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~firebase-app~firebase-messaging","7":"vendors~home~list","9":"SSOWrapperBase","10":"SidebarTemplate","11":"StoryTemplateChunkCustom","12":"StoryTemplateChunkListicle","13":"StoryTemplateChunkLiveBlog","14":"StoryTemplateChunkOther","15":"StoryTemplateChunkPhoto","16":"StoryTemplateChunkText","17":"StoryTemplateChunkVideo","18":"StoryTemplateChunkVisual","20":"firebase-app","22":"footer_1","23":"footer_2","24":"footer_3","25":"glide","26":"header_1","27":"header_2","28":"header_3","29":"header_4","30":"home","31":"list","32":"metypeFeedWidget","34":"qtc-parsecsv","35":"secret-mode","37":"single-layer-header_1","38":"single-layer-header_2","39":"single-layer-header_3","40":"single-layer-header_4","41":"single-layer-header_5","42":"story","43":"subscription","44":"vendors~StoryTemplateChunkVisual","45":"vendors~firebase-messaging","46":"vendors~qtc-react-youtube","47":"vendors~secret-mode","48":"vendors~story"}[chunkId]||chunkId) + "-" + "78b554ff242846b3897c" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"4":1,"7":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"35":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"48":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~eaaaa58d","1":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~f41b84c5","2":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","3":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~326164d8","4":"vendors~StoryTemplateChunkCustom~StoryTemplateChunkListicle~StoryTemplateChunkLiveBlog~StoryTemplate~5c0a4254","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"vendors~firebase-app~firebase-messaging","7":"vendors~home~list","9":"SSOWrapperBase","10":"SidebarTemplate","11":"StoryTemplateChunkCustom","12":"StoryTemplateChunkListicle","13":"StoryTemplateChunkLiveBlog","14":"StoryTemplateChunkOther","15":"StoryTemplateChunkPhoto","16":"StoryTemplateChunkText","17":"StoryTemplateChunkVideo","18":"StoryTemplateChunkVisual","20":"firebase-app","22":"footer_1","23":"footer_2","24":"footer_3","25":"glide","26":"header_1","27":"header_2","28":"header_3","29":"header_4","30":"home","31":"list","32":"metypeFeedWidget","34":"qtc-parsecsv","35":"secret-mode","37":"single-layer-header_1","38":"single-layer-header_2","39":"single-layer-header_3","40":"single-layer-header_4","41":"single-layer-header_5","42":"story","43":"subscription","44":"vendors~StoryTemplateChunkVisual","45":"vendors~firebase-messaging","46":"vendors~qtc-react-youtube","47":"vendors~secret-mode","48":"vendors~story"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"213da90d52914217d432","3":"31d6cfe0d16ae931b73c","4":"deb18478f447e4fb46b5","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"fd1f7b085319230ca3a7","8":"31d6cfe0d16ae931b73c","9":"a751517e4328b0ad33d7","10":"5942661adef3653aeeb9","11":"aab98437033cdcfc34b8","12":"d34ecc5c0885e7e66425","13":"934da174ea35a00ad28e","14":"a8a1592de62a68483843","15":"34ed72efea676428d602","16":"4edd49752d258091af26","17":"a5917c58592667f2c68d","18":"8fc1345e6a4c8676e91e","20":"31d6cfe0d16ae931b73c","22":"8e2ac9f97b5b41d27941","23":"beb7efde753797a08ff7","24":"7ca80661d31bb2a8c7c2","25":"5601a62b777eb193927d","26":"b62df725a743ef7cdd9d","27":"b8fa521d400acda09672","28":"a0e4ae4d7af91148cb55","29":"39bcd9f035232513555e","30":"04f39293b29b3016501f","31":"0cc8336e2e41bea4f8a5","32":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"499d1826a1fbbe7088dc","37":"6a204c697184cac15733","38":"76a3cf32a1465a026b21","39":"b782554ec0577faaae01","40":"2e5670a4a7a652866c2c","41":"37e9b6a5d3764d895066","42":"7c56b62a64d0b7588575","43":"000dfa8175a7616f19d7","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"c3df0332bf9c534f4de5","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"42": [
 				0,
 				1,
 				3,
 				4,
 				11,
 				12,
 				13,
 				14,
 				15,
 				16,
 				17,
 				44,
 				18
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 177);
